export default function Osoba(props) {
  return (
    <span id="a11y-osoba">
      <strong>{props.children}</strong>
    </span>
  );
}
